import script from "./WalletTopUpView.vue?vue&type=script&setup=true&lang=js"
export * from "./WalletTopUpView.vue?vue&type=script&setup=true&lang=js"

import "./WalletTopUpView.vue?vue&type=style&index=0&id=85e00f32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85e00f32"]])

export default __exports__